import { render, staticRenderFns } from "./TahsilatMakbuzuTaslak.vue?vue&type=template&id=31013d0a&scoped=true"
import script from "./TahsilatMakbuzuTaslak.vue?vue&type=script&lang=ts"
export * from "./TahsilatMakbuzuTaslak.vue?vue&type=script&lang=ts"
import style0 from "./TahsilatMakbuzuTaslak.vue?vue&type=style&index=0&id=31013d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31013d0a",
  null
  
)

export default component.exports